// extracted by mini-css-extract-plugin
module.exports = {"container":"ZahlungsStatus_container__16GzF","iconContainer":"ZahlungsStatus_iconContainer__SjM1A"};